import React, { useEffect, useRef } from 'react'
import './benifit.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Benifits = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='benifitsprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="beniftschlprnt">
                        <h2 >Key Benefits</h2>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg.png" alt="benifitcardoneimg" />
                                </div>
                                <img className='img-fluid' src="\assets\Chatandpay\profile.svg" alt="profileimg" />
                                <h3>No Personal Info Required</h3>
                                <p>Get started instantly - no phone number or email required. Just download and chat.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg2.png" alt="benifitcardoneimg" />
                                </div>
                               <img className='img-fluid' src="\assets\Chatandpay\Simple Crypto Payments.svg" alt="Simple Crypto Payments img" />
                                <h3>Simple Crypto Payments</h3>
                                <p>Send crypto as easily as sending a message, with gasless transactions (coming soon) and no complicated wallet addresses.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg3.png" alt="benifitcardoneimg" />
                                </div>
                               <img className='img-fluid' src="\assets\Chatandpay\Unified Experience.svg" alt="Unified Experience img" />
                                <h3>Unified Experience</h3>
                                <p>Chat and pay in one seamless interface - no more switching between messaging and payment apps.</p>
                            </div>
                            <div className="cardonebenifits"  ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg4.png" alt="benifitcardoneimg" />
                                </div>
                                <img className='img-fluid' src="\assets\Chatandpay\Complete Privacy.svg" alt="Complete Privacy" />
                                <h3>Complete Privacy</h3>
                                <p>End-to-end encrypted chats with secure transactions, giving you full control over your communications and payments.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benifits